// Use this before passing {...props} to a react element like div/span/etc
export default function stripBoardProps(props) {
  const { UI, Board, Subschema, Contents, ...rest } = props || {};
  return rest;
}
